var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { MarketConstants } from "../../constants/MarketConstants";
import { IdStyles } from "../../less/IdStyles";
import { selectContractInfo, selectContractRewardInfo, } from "../../selectors/selectContractInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { GridContainer } from "../generic/grid-layout/GridContainer";
import { actionModalTabSelect } from "../modals/actionModal";
import { GridItemMarket } from "./GridItemMarket";
import { IdMarketCategory } from "./IdMarketCategory";
var getContractDetails = function (contractInfo, contractRewardInfo, resources) {
    var orders = contractInfo.orders, remainingTime = contractInfo.remainingTime, visual = contractInfo.visual;
    var contractDetails = __assign({}, contractRewardInfo, { orders: [], remainingTime: remainingTime,
        visual: visual });
    contractDetails.orders = orders.map(function (order) {
        var inventoryResource = resources.find(function (val) { return val.typeId === order.resourceId; });
        var total = inventoryResource ? inventoryResource.amount : Long.ZERO;
        return __assign({}, order, { total: total });
    });
    return contractDetails;
};
var _MasterViewMarket = function (_a) {
    var contractInfo = _a.contractInfo, contractRewardInfo = _a.contractRewardInfo, resources = _a.resources, onShowMe = _a.onShowMe, onSelect = _a.onSelect;
    var _b = React.useState(0), selectedItemIndex = _b[0], setSelectedItemIndex = _b[1];
    React.useEffect(function () {
        if (contractInfo == undefined || contractRewardInfo == undefined || onSelect == undefined) {
            return;
        }
        var newItem = getContractDetails(contractInfo[selectedItemIndex], contractRewardInfo[selectedItemIndex], resources);
        onSelect(newItem);
    }, [contractInfo]);
    var onItemSelect = function (index) {
        var gridItem = getContractDetails(contractInfo[index], contractRewardInfo[index], resources);
        setSelectedItemIndex(index);
        if (onSelect) {
            onSelect(gridItem);
        }
    };
    var getGridItems = function () {
        var contractItems = contractInfo.map(function (contractItem, index) {
            return getContractDetails(contractItem, contractRewardInfo[index], resources);
        });
        var repeatTimes = MarketConstants.TotalContracts - contractItems.length;
        var lockedContract = {
            adventureXp: 0,
            buffAdventureXpAmount: Long.ZERO,
            buffMarketXpAmount: Long.ZERO,
            buffPlayerXpAmount: Long.ZERO,
            contractId: 0,
            isLocked: true,
            marketXp: 0,
            orders: [],
            playerXp: 0,
            rewards: [],
        };
        var contractLockedItems = Array(repeatTimes).fill(lockedContract);
        if (contractLockedItems.length > 0) {
            contractLockedItems[0] = __assign({}, lockedContract, { onShowMe: onShowMe });
        }
        contractItems = contractItems.concat(contractLockedItems);
        contractItems.forEach(function (contractItem) {
            contractItem.locaKey = contractItem.locaKey ? contractItem.locaKey : IdLoca.empty;
            contractItem.replacements = new Map();
        });
        return contractItems;
    };
    if (!contractInfo || !contractRewardInfo) {
        return React.createElement(React.Fragment, null);
    }
    var marketGridItems = getGridItems();
    return (React.createElement("div", { className: "market-menu__master-view " + IdStyles.MarketMenuMasterViewBackground },
        React.createElement(GridContainer, { items: marketGridItems, gridItemRenderer: GridItemMarket, onSelect: onItemSelect, selectedIndex: selectedItemIndex })));
};
var mapState = function (state) { return ({
    contractInfo: selectContractInfo(state),
    contractRewardInfo: selectContractRewardInfo(state),
    resources: state.inventoryInfo.resource,
}); };
var mapDispatch = function (dispatch) { return ({
    onShowMe: function () { return dispatch(actionModalTabSelect(IdMarketCategory.Improvement)); },
}); };
export var MasterViewMarket = connect(mapState, mapDispatch)(_MasterViewMarket);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/MasterViewMarket.tsx
// module id = 2717
// module chunks = 3